import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import { Home } from './pages/Home';
import LoginPage from './pages/LoginPage';
import CompetitionsPage from './pages/CompetitionsPage';
import CompetitionDetailsPage from './pages/CompetitionDetailsPage';
import StandingsPage from './pages/StandingsPage';
import FixturesCalendarPage from './pages/FixturesCalendarPage';
import MatchDetailsPage from './pages/MatchDetailsPage';
import TeamProfilePage from './pages/TeamProfilePage';
import PlayerProfilePage from './pages/PlayerProfilePage';
import CaptainDashboard from './pages/CaptainDashboard';
import LogMatchPage from './pages/LogMatchPage';
import ReviewMatchPage from './pages/ReviewMatchPage';
import RulesPage from './pages/RulesPage';
import OrganiserDashboard from './pages/OrganiserDashboard';
import CreateCompetition from './pages/CreateCompetition';
import EditCompetition from './pages/EditCompetition';
import TeamManagementPage from './pages/TeamManagementPage';
import BracketPage from './pages/BracketPage';
import RoomPage from './pages/RoomPage';
import { RedirectToCompFixtures, RedirectToCompResults } from './pages/RedirectToActiveCompetition';
import AppLandingPage from './pages/AppLandingPage';
import NotFound from './pages/NotFound';

import { RouteErrorBoundary } from './components/error/ErrorBoundary';

export const router = createBrowserRouter([
  // ── Tournament Room — standalone, no header/footer ──────────────────────────
  {
    path: '/room/:code',
    element: <RoomPage />,
    errorElement: <RouteErrorBoundary />,
  },

  // ── App landing page — standalone, no header/footer ────────────────────────
  {
    path: '/app',
    element: <AppLandingPage />,
    errorElement: <RouteErrorBoundary />,
  },

  // ── Main app layout ──────────────────────────────────────────────────────────
  {
    path: '/',
    element: <App />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'login',
        element: <LoginPage />,
      },
      // User Story 1: Public Match Results Viewing
      {
        path: 'competitions',
        element: <CompetitionsPage />,
      },
      {
        path: 'competitions/:competitionId',
        element: <CompetitionDetailsPage />,
      },
      {
        path: 'competitions/:competitionId/standings',
        element: <StandingsPage />,
      },
      {
        path: 'competitions/:competitionId/fixtures',
        element: <FixturesCalendarPage />,
      },
      {
        path: 'competitions/:competitionId/bracket',
        element: <BracketPage />,
      },
      {
        path: 'standings',
        element: <StandingsPage />,
      },
      {
        path: 'fixtures',
        element: <RedirectToCompFixtures />,
      },
      {
        path: 'results',
        element: <RedirectToCompResults />,
      },
      {
        path: 'matches/:matchId',
        element: <MatchDetailsPage />,
      },
      {
        path: 'teams/:teamId',
        element: <TeamProfilePage />,
      },
      {
        path: 'players/:playerId',
        element: <PlayerProfilePage />,
      },
      // Placeholder routes for future user stories
      {
        path: 'rules',
        element: <RulesPage />,
      },
      // User Story 2: Captain Match Logging
      {
        path: 'captain/dashboard',
        element: <CaptainDashboard />,
      },
      {
        path: 'captain/log-match/:matchId',
        element: <LogMatchPage />,
      },
      {
        path: 'captain/review-match/:matchId',
        element: <ReviewMatchPage />,
      },
      {
        path: 'organizer/dashboard',
        element: <OrganiserDashboard />,
      },
      {
        path: 'organizer/competitions/create',
        element: <CreateCompetition />,
      },
      {
        path: 'organizer/competitions/:competitionId/teams',
        element: <TeamManagementPage />,
      },
      {
        path: 'organizer/competitions/:competitionId/edit',
        element: <EditCompetition />,
      },
      // 404 catch-all route
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
], {
  future: {
    v7_startTransition: true,
  },
});

export default router;
